import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { CoinActivity } from '../modal';

export default function reducer(
  state: CoinActivity = new CoinActivity(),
  action: AnyAction,
) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.COIN_ACTIVITY_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.COIN_ACTIVITY_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.COIN_ACTIVITY_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
